import { css } from '@emotion/react'
import { mTheme } from '../../../style/themes'

export const container: Style = css({
  display: 'flex',
  color: mTheme.fontColor.plain.primary,
  gap: mTheme.size.XS,
})

export let datePickerGroup = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: mTheme.size.S,
  border: `2px solid ${mTheme.borderColor.secondary}`,
  borderRadius: mTheme.radius.primary,
  background: mTheme.backgroundColor.primary,
})

export let hidden = css({ display: 'none' })

export let dateInput: Style = css({
  display: 'flex',
  paddingLeft: mTheme.size.S,
  paddingTop: mTheme.size.XS,
  paddingBottom: mTheme.size.XS,
  paddingRight: mTheme.size.M,
})

export let dateSegment: Style = css({})

export let popoverOpenButton = css({
  color: mTheme.fontColor.plain.tertiary,
  forcedColorAdjust: 'none',
  borderRadius: mTheme.radius.primary,
  border: 'none',
  marginLeft: '-1.929rem',
  width: '1.229rem',
  height: '1.229rem',
  padding: mTheme.size.XS,
  fontSize: mTheme.fontSize.S,
  boxSizing: 'content-box',

  '&[data-pressed]': {
    boxShadow: 'none',
    background: mTheme.backgroundColor.primary,
    color: mTheme.fontColor.plain.tertiary,
  },

  '&[data-focus-visible]': {
    outline: `2px solid ${mTheme.color.focusRing}`,
    outlineOffset: 2,
  },
})

export let popover: Style = css({
  maxWidth: 'unset',
  background: mTheme.backgroundColor.primary,
  padding: mTheme.size.S,
  border: `2px solid ${mTheme.borderColor.secondary}`,
  borderRadius: mTheme.radius.primary,
  boxShadow: `${mTheme.backgroundColor.primary} 0px 8px 24px`,
})

export const timeContainer: Style = css({
  display: 'flex',
  alignItems: 'center',
  padding: mTheme.size.S,
  paddingTop: mTheme.size.XS,
  paddingBottom: mTheme.size.XS,
  border: `2px solid ${mTheme.borderColor.secondary}`,
  borderRadius: mTheme.radius.primary,
  background: mTheme.backgroundColor.primary,
})

export const timeInput: Style = css({
  display: 'flex',
})

export const timeSelect: Style = css({
  marginTop: 0,
})
